import StorageLs from "vue-ls";

let ls: any;

if (process.client) {
  const storage = StorageLs.useStorage({
    namespace: "legal_cloud_",
    name: "ls",
    storage: "local",
  });
  ls = storage.ls;
}

const Storage = {
  get(name: string, def?: any) {
    return ls.get(name, def);
  },
  setOptions(options: Record<string, any> = {}) {
    ls.setOptions(options);
  },
  set(name: string, value: any, expire?: number) {
    ls.set(name, value, expire);
  },
  key(index: number) {
    return ls.key(index);
  },
  remove(name: string) {
    return ls.remove(name);
  },
  clear() {
    ls.clear();
  },
  on(name: string, callback: (...args: any[]) => void) {
    ls.on(name, callback);
  },
  off(name: string, callback: (...args: any[]) => void) {
    ls.off(name, callback);
  },
};

export default Storage;
